import styled from 'styled-components'

interface PanelProps {
  padding?: string
}

const Panel = styled.div<PanelProps>`
  padding: ${(p) => p.padding ?? '20px'};
  background-color: ${(p) => p.theme.BACKGROUND_SURFACE};
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
`

export default Panel
